import esContent from './logoBuilder.es';

export default {
  ...esContent,
};
